<div class="text-center font-productive-heading-03 p-5">
  <ng-container *ngIf="message; else defaultMessage">
    {{ message }}
  </ng-container>
  <ng-template #defaultMessage>
    No items found.
  </ng-template>
</div>